import React from 'react';

import ReactDOM from 'react-dom';

import App from './App';

class WebComponent extends HTMLElement {
  connectedCallback() {
    const cardSize = this.getAttribute('cardSize');
    const componentType = this.getAttribute('componentType');

    ReactDOM.render(<App componentType={componentType} cardSize={cardSize} />, this);
  }
}

const ELEMENT_ID = 'voebiz-react-my-account';

if (!customElements.get(ELEMENT_ID)) {
  customElements.define(ELEMENT_ID, WebComponent);
}
